import CapRulesCell from './CapRulesCell'
import SickDaysRulesMixin from './SickDaysRulesMixin'

class SickDaysCapRulesCell extends CapRulesCell {
    constructor() {
        super()
        this.mixin = new SickDaysRulesMixin()
    }
}

export default SickDaysCapRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/SickDaysCapRulesCell.js